export enum JwtType {
  ACCESS = "accessToken",
  REFRESH = "refreshToken",
}
